var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.themeClassName,attrs:{"id":"app"}},[_c('router-view'),_c('TickTack',{attrs:{"useScopedSlot":false,"tickEverySeconds":60,"emitAfterTicks":1,"emit":"global_tick"},on:{"global_tick":_vm.onGlobalTick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }